import AuditDomainChip from "@/components/auth/AuditDomainChip";

type ClaimHandoffIntroProps = {
  hostname: string;
};

export default function ClaimHandoffIntro({ hostname }: ClaimHandoffIntroProps) {
  return (
    <div className="mb-8 space-y-6">
      <div className="text-center">
        <h1 id="login-heading" className="mb-3 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Create an account to keep this report
        </h1>
        <p className="text-base leading-relaxed text-gray-600 sm:text-lg">We’ll save this report to your account.</p>
      </div>

      <AuditDomainChip auditUrl={`https://${hostname}`} />
    </div>
  );
}
